import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abCurrencySymbol'
})
export class AbCurrencySymbolPipe implements PipeTransform {
  public map = {
    USD: '$',
    EURO: '€',
    EUR: '€',
    AWG: 'ƒ',
    ANG: 'ƒ',
    GBP: '£'
  };
  transform(value: any): any {
    return this.map[value];
  }
}
